module.exports = __webpack_public_path__ + "f312b8c21aa7f7b3a98484d49922d890.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/piano/17_E3.mp3
// module id = 97
// module chunks = 0